/* tslint:disable */
/* eslint-disable */
/**
 * Quotes Management API
 * API for managing quotes
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IdLabel } from './IdLabel';
import {
    IdLabelFromJSON,
    IdLabelFromJSONTyped,
    IdLabelToJSON,
    IdLabelToJSONTyped,
} from './IdLabel';
import type { GenericColors } from './GenericColors';
import {
    GenericColorsFromJSON,
    GenericColorsFromJSONTyped,
    GenericColorsToJSON,
    GenericColorsToJSONTyped,
} from './GenericColors';

/**
 * 
 * @export
 * @interface AdminQuoteSummaryDto
 */
export interface AdminQuoteSummaryDto {
    /**
     * 
     * @type {string}
     * @memberof AdminQuoteSummaryDto
     */
    id: string;
    /**
     * 
     * @type {Date}
     * @memberof AdminQuoteSummaryDto
     */
    date: Date;
    /**
     * 
     * @type {GenericColors}
     * @memberof AdminQuoteSummaryDto
     */
    statusColor: GenericColors;
    /**
     * 
     * @type {string}
     * @memberof AdminQuoteSummaryDto
     */
    statusLabel: string;
    /**
     * 
     * @type {string}
     * @memberof AdminQuoteSummaryDto
     */
    support: string;
    /**
     * 
     * @type {IdLabel}
     * @memberof AdminQuoteSummaryDto
     */
    contractIdentifier: IdLabel;
    /**
     * 
     * @type {IdLabel}
     * @memberof AdminQuoteSummaryDto
     */
    quoteIdentifier: IdLabel;
    /**
     * 
     * @type {string}
     * @memberof AdminQuoteSummaryDto
     */
    riskId?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminQuoteSummaryDto
     */
    borrowerProjectId?: string;
    /**
     * 
     * @type {Array<IdLabel>}
     * @memberof AdminQuoteSummaryDto
     */
    insureds: Array<IdLabel>;
    /**
     * 
     * @type {string}
     * @memberof AdminQuoteSummaryDto
     */
    branchCode: string;
    /**
     * 
     * @type {string}
     * @memberof AdminQuoteSummaryDto
     */
    product: string;
    /**
     * Nom lisible du produit (complète le code `product`). Absent si null.
     * @type {string}
     * @memberof AdminQuoteSummaryDto
     */
    productLabel?: string | null;
    /**
     * Libellé du tunnel. Absent si null.
     * @type {string}
     * @memberof AdminQuoteSummaryDto
     */
    tunnelLabel?: string | null;
    /**
     * Date d'effet (ISO). Absent si null.
     * @type {Date}
     * @memberof AdminQuoteSummaryDto
     */
    effectiveDate?: Date | null;
    /**
     * Fin de validité de l'offre (ISO). Absent si null.
     * @type {Date}
     * @memberof AdminQuoteSummaryDto
     */
    endDate?: Date | null;
    /**
     * 
     * @type {number}
     * @memberof AdminQuoteSummaryDto
     */
    clientPrice?: number;
    /**
     * 
     * @type {string}
     * @memberof AdminQuoteSummaryDto
     */
    owner: string;
    /**
     * Number of unread notifications for this quote
     * @type {number}
     * @memberof AdminQuoteSummaryDto
     */
    unreadNotificationCount?: number;
    /**
     * 
     * @type {string}
     * @memberof AdminQuoteSummaryDto
     */
    brokerId: string;
    /**
     * 
     * @type {string}
     * @memberof AdminQuoteSummaryDto
     */
    brokerName: string;
    /**
     * 
     * @type {string}
     * @memberof AdminQuoteSummaryDto
     */
    plateformeId: string;
    /**
     * 
     * @type {string}
     * @memberof AdminQuoteSummaryDto
     */
    plateformeName: string;
}



/**
 * Check if a given object implements the AdminQuoteSummaryDto interface.
 */
export function instanceOfAdminQuoteSummaryDto(value: object): value is AdminQuoteSummaryDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('date' in value) || value['date'] === undefined) return false;
    if (!('statusColor' in value) || value['statusColor'] === undefined) return false;
    if (!('statusLabel' in value) || value['statusLabel'] === undefined) return false;
    if (!('support' in value) || value['support'] === undefined) return false;
    if (!('contractIdentifier' in value) || value['contractIdentifier'] === undefined) return false;
    if (!('quoteIdentifier' in value) || value['quoteIdentifier'] === undefined) return false;
    if (!('insureds' in value) || value['insureds'] === undefined) return false;
    if (!('branchCode' in value) || value['branchCode'] === undefined) return false;
    if (!('product' in value) || value['product'] === undefined) return false;
    if (!('owner' in value) || value['owner'] === undefined) return false;
    if (!('brokerId' in value) || value['brokerId'] === undefined) return false;
    if (!('brokerName' in value) || value['brokerName'] === undefined) return false;
    if (!('plateformeId' in value) || value['plateformeId'] === undefined) return false;
    if (!('plateformeName' in value) || value['plateformeName'] === undefined) return false;
    return true;
}

export function AdminQuoteSummaryDtoFromJSON(json: any): AdminQuoteSummaryDto {
    return AdminQuoteSummaryDtoFromJSONTyped(json, false);
}

export function AdminQuoteSummaryDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdminQuoteSummaryDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'date': (new Date(json['date'])),
        'statusColor': GenericColorsFromJSON(json['statusColor']),
        'statusLabel': json['statusLabel'],
        'support': json['support'],
        'contractIdentifier': IdLabelFromJSON(json['contractIdentifier']),
        'quoteIdentifier': IdLabelFromJSON(json['quoteIdentifier']),
        'riskId': json['riskId'] == null ? undefined : json['riskId'],
        'borrowerProjectId': json['borrowerProjectId'] == null ? undefined : json['borrowerProjectId'],
        'insureds': ((json['insureds'] as Array<any>).map(IdLabelFromJSON)),
        'branchCode': json['branchCode'],
        'product': json['product'],
        'productLabel': json['productLabel'] == null ? undefined : json['productLabel'],
        'tunnelLabel': json['tunnelLabel'] == null ? undefined : json['tunnelLabel'],
        'effectiveDate': json['effectiveDate'] == null ? undefined : (new Date(json['effectiveDate'])),
        'endDate': json['endDate'] == null ? undefined : (new Date(json['endDate'])),
        'clientPrice': json['clientPrice'] == null ? undefined : json['clientPrice'],
        'owner': json['owner'],
        'unreadNotificationCount': json['unreadNotificationCount'] == null ? undefined : json['unreadNotificationCount'],
        'brokerId': json['brokerId'],
        'brokerName': json['brokerName'],
        'plateformeId': json['plateformeId'],
        'plateformeName': json['plateformeName'],
    };
}

export function AdminQuoteSummaryDtoToJSON(json: any): AdminQuoteSummaryDto {
    return AdminQuoteSummaryDtoToJSONTyped(json, false);
}

export function AdminQuoteSummaryDtoToJSONTyped(value?: AdminQuoteSummaryDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'date': ((value['date']).toISOString().substring(0,10)),
        'statusColor': GenericColorsToJSON(value['statusColor']),
        'statusLabel': value['statusLabel'],
        'support': value['support'],
        'contractIdentifier': IdLabelToJSON(value['contractIdentifier']),
        'quoteIdentifier': IdLabelToJSON(value['quoteIdentifier']),
        'riskId': value['riskId'],
        'borrowerProjectId': value['borrowerProjectId'],
        'insureds': ((value['insureds'] as Array<any>).map(IdLabelToJSON)),
        'branchCode': value['branchCode'],
        'product': value['product'],
        'productLabel': value['productLabel'],
        'tunnelLabel': value['tunnelLabel'],
        'effectiveDate': value['effectiveDate'] == null ? undefined : ((value['effectiveDate'] as any).toISOString()),
        'endDate': value['endDate'] == null ? undefined : ((value['endDate'] as any).toISOString()),
        'clientPrice': value['clientPrice'],
        'owner': value['owner'],
        'unreadNotificationCount': value['unreadNotificationCount'],
        'brokerId': value['brokerId'],
        'brokerName': value['brokerName'],
        'plateformeId': value['plateformeId'],
        'plateformeName': value['plateformeName'],
    };
}

